/* eslint-disable react-hooks/exhaustive-deps */
import { ButtonDS, useDevice } from "get-life-storybook-ts";
import { useContext, useEffect, useState } from "react";
import { FormBuilderContext } from "../../../context/FormBuilder.context";

const FormButton = ({
  showButton,
  isLoading,
  isOneChoinceQuestion,
  isSticky = false,
  componentName,
  translate,
  handleSubmit,
  question,
  answer,
  goBack,
  customDisabled,
  questionStack,
  currentIndex
}) => {
  const { disabled } = useContext(FormBuilderContext);
  const { isMobile } = useDevice();
  const isAswerDiferentFromNone = answer && answer !== "none";
  const hasNoNoneLabelOption =
    question && question.type === "select_multiple" && !isAswerDiferentFromNone;
  const isOptionalCheckbox = question.type === "checkbox_optional";
  const continueLabel = translate("continuar");
  const [labelText, setLabelText] = useState(continueLabel);
  const [disabledButton, setDisabledButton] = useState(
    customDisabled || disabled
  );

  useEffect(() => {

    if (componentName === "biometry") {
      setDisabledButton(customDisabled);
    } else {
      setDisabledButton(disabled);
    }
    
  }, [disabled, customDisabled]);

  useEffect(() => {
    if (isAswerDiferentFromNone) {
      setLabelText(continueLabel);
    }

    if (hasNoNoneLabelOption) {
      setLabelText(translate(continueLabel));
    }

    if (isOptionalCheckbox && !isAswerDiferentFromNone) {
      setLabelText(translate("productQuestions.label.noNone"));
    }
  }, [question.type, labelText, answer, translate]);

  return (
    <div className={isOptionalCheckbox || isSticky ? "inBottomButtons" : isMobile ? "mobileShow" : "buttonsContainer"}>
      {showButton === true &&
        isLoading === false &&
        !isOneChoinceQuestion &&
        componentName !== "external_underwriting" && (
          <div
            className={
              isMobile
                ? "formBuilder-buttonContainer-mobile formBuilder-buttonContainer-mobile-primary"
                : "formBuilder-buttonContainer"
            }
          >
            <ButtonDS
              label={labelText || continueLabel}
              onClick={handleSubmit}
              disabled={disabledButton}
              className="w-full"
              rightIcon="ArrowRightIcon"
            />
          </div>
        )}
      {!!question &&
        (currentIndex !== undefined ? currentIndex > 0 : questionStack.length > 0) &&
        componentName !== "external_underwriting" && (
          <div
            className={
              isMobile
                ? "formBuilder-buttonContainer-mobile goBackButtonWidthMobile"
                : "formBuilder-buttonContainer"
            }
          >
            <ButtonDS
              label={translate("questions.button.goBack")}
              onClick={goBack}
              buttonType="secondary"
              ghost={true}
              className="w-full"
              leftIcon="ArrowBackIcon"
            />
          </div>
        )}
    </div>
  );
};

export default FormButton;
